<template>
  <div class="row">
    <div class="col-md-3 col-sm-6 col-12">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-primary"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                Colis Livrés Facturés
              </span>
              <h4 class="fw-black mb-8 lh-1">{{ dashCount?.Parcels?.deliveredparcelsinvoiced ?? 0 }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3 col-sm-6 col-12">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-success"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                Colis Livrés Non Facturés
                  </span>
                  <h4 class="fw-black mb-8 lh-1"> {{ dashCount?.Parcels?.deliveredparcelsnotinvoiced ?? 0 }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="col-md-3 col-sm-6 col-12">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-warning"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                Colis En cours
              </span>
              <h4 class="fw-black mb-8 lh-1">{{ dashCount?.Parcels?.inprogressparcels ?? 0 }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>



    <div class="col-md-3 col-sm-6 col-12">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-danger"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                Colis Retournés
              </span>
              <h4 class="fw-black mb-8 lh-1">{{ dashCount?.Parcels?.returnedparcels ?? 0 }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="col-md-3 col-sm-6 col-12">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-info"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                Produits
              </span>
              <h4 class="fw-black mb-8 lh-1">{{ dashCount?.Products ?? 0 }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3 col-sm-6 col-12">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-primary"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                Bons de Livraison
              </span>
              <h4 class="fw-black mb-8 lh-1"> {{ dashCount?.BL ?? 0 }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3 col-sm-6 col-12">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-secondary"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                Bons de retour
              </span>
              <h4 class="fw-black mb-8 lh-1">  {{ dashCount?.BR ?? 0 }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-3 col-sm-6 col-12">
      <div class="card mb-25 border-0 rounded-0 bg-white stats-box">
        <div class="card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
          <div class="d-flex align-items-center">
            <div
              class="icon position-relative rounded-circle text-center text-success"
            >
              <i class="flaticon-sterile-box"></i>
            </div>
            <div class="title ms-15">
              <span
                class="d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis"
              >
                Factures
              </span>
              <h4 class="fw-black mb-8 lh-1">{{ dashCount?.INV ?? 0 }}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from "vue";

import statsBoxes from "./statsBoxes.json";

export default defineComponent({
  name: "StatsBoxes",
  props: {
    dashData: {
      type: Object,
      required: false,
    },
  },
  setup: (props) => {
    const dashCount = ref(props.dashData);

    watch(
      () => props.dashData,
      (newVal) => {
        dashCount.value = newVal;
        console.log("dashData changed:", newVal);
      }
    );


    return {
      stats: statsBoxes,
      dashCount,
    };
  },
});
</script>